export var stringToObject = function (raw, d1, d2) {
    var o = {};
    for (var _i = 0, _a = raw.split(d1); _i < _a.length; _i++) {
        var part = _a[_i];
        var _b = part.split(d2), k = _b[0], v = _b[1];
        o[k] = v;
    }
    return o;
};
//# sourceMappingURL=util.js.map